export const getTofuPackage = newProduct => {
  const newTofuPackage = {
    UPC: newProduct.UPC,
    Calcium: newProduct.Calcium,
    IsPlainRefrigerated: newProduct.IsPlainRefrigerated,
    Texture: newProduct.Texture,
    OtherTexture: newProduct.OtherTexture,
    PackageSize: newProduct.PackageSize,
    Organic: newProduct.Organic,
  }
  return newTofuPackage
}

export const updateTofuPackage = newProduct => {
  const newTofuPackage = {
    UPC: newProduct.UPC,
    Calcium: newProduct.Calcium,
    IsPlainRefrigerated: newProduct.IsPlainRefrigerated,
    Texture: newProduct.Texture,
    OtherTexture: newProduct.OtherTexture,
    PackageSize: newProduct.PackageSize,
    Organic: newProduct.Organic,
  }
  return newTofuPackage
}
